import type {Command, EditorView} from '@codemirror/view'

import {inlineFormatter} from './utils'

export const formatBold: Command = (view: EditorView) => {
  return inlineFormatter(view, 'strong')
}

export const formatItalic: Command = (view: EditorView) => {
  return inlineFormatter(view, 'emphasis')
}

export const formatInlineCode: Command = (view: EditorView) => {
  return inlineFormatter(view, 'inlineCode')
}

export const formatStrikethrough: Command = (view: EditorView) => {
  return inlineFormatter(view, 'delete')
}
